<script lang="ts" setup>
import type { DynamicAuctionItemList } from '@autobid/strapi-integration/rest/components'
import type { CarsListCar, SearchListCar } from '@autobid/ui/types/Car'
import { useIsMobile } from '@autobid/ui/composables/useIsMobile'
import { inject } from 'vue'

interface Props {
  car: CarsListCar | SearchListCar
}

defineProps<Props>()

const auctionStrapiData = inject<DynamicAuctionItemList>('auction-strapi-data')

const isMobile = useIsMobile()
</script>

<template>
  <DynamicAuctionItemListCarPrice v-if="!isMobile" v-bind="$attrs" :car="car" />

  <ElementsCarLocationInfo
    v-bind="$attrs"
    class="flex-col xl:w-auto"
    :class="{
      'w-1/3 items-end': auctionStrapiData?.type === 'carList',
      'w-1/4': auctionStrapiData?.type === 'carSearch',
    }"
    :car="car"
  />

  <DynamicAuctionItemListCarAuctionInfo :car="car" v-bind="$attrs" />
</template>
